<template>
  <div>
    <v-data-table :items="requerimiento.adjuntos" hide-actions hide-headers v-if="requerimiento.adjuntos.length"
                  no-data-text="No hay datos disponibles">
      <template slot="items" slot-scope="props">
        <tr class="row-element" :key="props.item.asset.id">
          <td><a :href="props.item.asset.url" target="_blank">{{ props.item.asset.name }}</a></td>
          <td>{{ props.item.uploadDate }}</td>
          <td class="text-xs-left">{{ props.item.asset.description }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    requerimiento: Object
  },

  methods: {
    isValid () {
      return true
    },
    isModified () {
      return false
    },
    hasAddedFiles () {
      return false
    },
    hasRemovedFiles () {
      return false
    },
    getAddedFiles () {
      return []
    },
    getRemovedFiles () {
      return []
    },
    getModifiedFiles () {
      return []
    },
    cleanAddedFiles () {},
    cleanRemovedFiles () {},
    cleanModifiedFiles () {},
    startLoading () {},
    finishLoading () {}
  }
}
</script>

<style scoped>
a {
  color: #1787c9;
}
.row-element {
  background-color: #f0f0f2;
}
</style>
